import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=07b0c2d8"
import script from "./Future.vue?vue&type=script&lang=js"
export * from "./Future.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports